module.exports = __webpack_public_path__ + "static/assets/3ff581f311dd9f9950dfc7ce6ba65e92.svg";